import { object } from "yup";
export const a5Part1DataSchema = object({});
export const exampleA5Data = [
    {
        data: {},
    },
];
//# sourceMappingURL=a5.js.map